var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"container"},[_c('vs-row',[_c('vs-col',[_c('b-card',{attrs:{"title":_vm.$t('htmlTemplate.title')}},[_c('create-new-template'),_c('br'),_c('templates-table',{attrs:{"columns":_vm.customerTemplates.columns}})],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }